// Tournament data shared across components
export const TOURNAMENT = {
  name: "PROXIMA LEAGUE",
  edition: "EDICIÓN I · 2026",
  city: "GIRONA",
  venue: "Totem Sports Center",
  venueCity: "Tordera",
  dates: "25 OCTUBRE",
  registrationOpens: "1 de agosto",
  totalTeams: 16,
  format: "Liga + Eliminatoria",
  minPlayers: 8,
  maxPlayers: 12,
  startingPlayers: 7,
  price: 150,
  prize: 1000,
  whatsappNumber: "34618225121",
  contactEmail: "info@proximaleague.com",
};

export const WHATSAPP_LINK = `https://wa.me/${TOURNAMENT.whatsappNumber}?text=${encodeURIComponent(
  "Hola, quiero inscribir mi equipo en PROXIMA LEAGUE."
)}`;

export const MAILTO_LINK = `mailto:${TOURNAMENT.contactEmail}?subject=${encodeURIComponent(
  "Inscripción PROXIMA LEAGUE"
)}`;
